import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lead-loading-page',
  templateUrl: './lead-loading-page.component.html',
  styleUrls: ['./lead-loading-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeadLoadingPageComponent {}
